import React from "react";

import { Trans } from "@lingui/macro";
import { DateTime } from "luxon";

import Typography from "@mui/material/Typography";

import SideNavButtonIcon from "@app/analytics/components/SideNav/SideNavButtonIcon";
import useDailyRead from "@app/analytics/hooks/recordings/useDailyRead";
import ROUTES from "@app/common/routes";
import { getAppUrl } from "@app/utils/utils";

import Link from "@rui/Link";
import { Row } from "@rui/Stack";

import { SideNavButton, SideNavItemContainer } from "./styles";
import PlayIcon from "../PlayClip/PlayIcon";

const SideNavDailyRead = ({ expanded }: { expanded: boolean }) => {
  const { metadata } = useDailyRead();
  if (!metadata?.id) {
    return null;
  }

  const dailyReadPage = getAppUrl(ROUTES.dailyReadById(metadata.id));
  const date = metadata.date.toLocaleString(DateTime.DATE_FULL);

  return (
    <SideNavItemContainer sx={{ padding: 0 }} expanded={expanded}>
      <Link to={dailyReadPage}>
        <SideNavButton expanded={expanded}>
          <Row variant="left" spacing={1}>
            <SideNavButtonIcon size="sm" Icon={PlayIcon} />
            <Typography fontWeight={500} variant="bodySecondaryReg" noWrap>
              <Trans>Daily Read</Trans>
            </Typography>{" "}
            <Typography variant="bodySecondaryReg" noWrap>
              {date}
            </Typography>
          </Row>
        </SideNavButton>
      </Link>
    </SideNavItemContainer>
  );
};

export default SideNavDailyRead;
